/**
 * Constants for the Visual Story Board feature.
 */

import {
  BookOpen, User, Target, Zap, MapPin, Lightbulb, Sparkles, Link2,
} from 'lucide-react';

/**
 * The 8 card types the board supports. `tone` reuses the app's existing
 * Badge palette (coral/sage/yellow/blue/cream); `outline` distinguishes a
 * second type sharing a tone without introducing a new color.
 */
export const NODE_TYPES = [
  { type: 'chapter', label: 'Chapter', emoji: '📖', icon: BookOpen, tone: 'blue' },
  { type: 'character', label: 'Character', emoji: '👤', icon: User, tone: 'coral' },
  { type: 'plot', label: 'Plot Point', emoji: '🎯', icon: Target, tone: 'sage' },
  { type: 'conflict', label: 'Conflict', emoji: '⚡', icon: Zap, tone: 'coral', outline: true },
  { type: 'location', label: 'Location', emoji: '📍', icon: MapPin, tone: 'cream' },
  { type: 'idea', label: 'Idea', emoji: '💡', icon: Lightbulb, tone: 'yellow' },
  { type: 'foreshadowing', label: 'Foreshadowing', emoji: '🔮', icon: Sparkles, tone: 'yellow', outline: true },
  { type: 'event', label: 'Event', emoji: '🔗', icon: Link2, tone: 'sage', outline: true },
];

export const NODE_TYPE_MAP = Object.fromEntries(NODE_TYPES.map((t) => [t.type, t]));

export const DEFAULT_NODE_SIZE = { width: 220, height: 108 };

export const STATUS_OPTIONS = [
  { value: 'idea', label: 'Idea' },
  { value: 'planned', label: 'Planned' },
  { value: 'drafted', label: 'Drafted' },
  { value: 'revised', label: 'Revised' },
  { value: 'complete', label: 'Complete' },
];

/** Free-text suggestions for connection labels — not an enum. */
export const EDGE_LABEL_SUGGESTIONS = [
  'reveals', 'foreshadows', 'causes', 'resolves', 'conflicts with', 'takes place in', 'mirrors',
];

export const BOARD_EMPTY_MESSAGE = {
  heading: 'Your story, laid out.',
  subheading: 'Add a card for a character, a chapter, a plot point — start seeing how your story connects.',
};
